import { render } from "./App.vue?vue&type=template&id=0c3f211c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0c3f211c&lang=css"
import "./App.vue?vue&type=style&index=1&id=0c3f211c&scoped=true&lang=scss"

import exportComponent from "D:\\work\\webGl\\chery-ruihu9\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3f211c"]])

export default __exports__